import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-search-btn',
  templateUrl: './search-btn.component.html',
  styleUrls: ['./search-btn.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SearchBtnComponent {
  @Input() className: string;
  constructor() { }
}
